import { ApiManager } from '../core/api-manager';
import { settings } from '../config/settings';
import { parseSql } from './format';

/**
 * Chiamate custom del motore di prenotazione (api/custom_classes/BookingEngine.php).
 * Rispondono con { success, data, message, error_code }.
 */

async function getAvailability(idSala, dal, al) {
    let body = {
        idSala: idSala,
        dal: dal,
        al: al
    }
    let response = await ApiManager.sendAuthenticatedRequest('/custom/get_availability', body)
    return response;
}

/** `durata`: ore intere, oppure 'giornata' per la giornata intera. */
async function checkAvailability(idSala, durata, inizio) {
    let body = {
        idSala: idSala,
        ...(durata === 'giornata' ? { giornata: 1 } : { ore: durata }),
        inizio: inizio
    }
    let response = await ApiManager.sendAuthenticatedRequest('/custom/check_availability', body)
    return response;
}

async function createBooking(data) {
    let response = await ApiManager.sendAuthenticatedRequest('/custom/create_booking', data)
    return response;
}

async function cancelBooking(id, motivo) {
    let body = {
        id: id,
        motivo_annullamento: motivo
    }
    let response = await ApiManager.sendAuthenticatedRequest('/custom/cancel_booking', body)
    return response;
}


/**
 * Vero se all'inizio manca meno tempo di quanto la sala chieda di preavviso:
 * oltre quel termine l'annullamento non cancella l'importo dovuto.
 *
 * Sta qui e non nella pagina perche' la regola e' la stessa dovunque si
 * offra l'annullamento, ed erano gia' due i posti che lo offrono.
 */
export function fuoriTermine(prenotazione) {
    const inizio = parseSql(prenotazione.inizio);
    if (!inizio) return false;
    const soglia = prenotazione.idSala && prenotazione.idSala.annullamento_ore
        ? parseInt(prenotazione.idSala.annullamento_ore, 10)
        : settings.booking.cancelDeadlineHours;
    return (inizio.getTime() - Date.now()) / 3600000 < soglia;
}

/**
 * Se una prenotazione annullata va pagata lo stesso, detto in chiaro.
 * L'esito lo fissa il backend al momento dell'annullamento; null per le
 * prenotazioni non annullate o annullate prima che lo si registrasse.
 */
export function esitoAnnullamento(prenotazione) {
    const v = prenotazione.annullata_fuori_termine;
    if (v === null || v === undefined || v === '') return null;
    return parseInt(v, 10) === 1
        ? { dovuto: true, label: "Oltre il termine: l'importo resta dovuto" }
        : { dovuto: false, label: 'Entro il termine: nessun addebito' };
}


export const BookingManager = {
    getAvailability: getAvailability,
    checkAvailability: checkAvailability,
    createBooking: createBooking,
    cancelBooking: cancelBooking
};
